import { Pipe, PipeTransform } from '@angular/core';
import { addMonths, formatDuration, intervalToDuration } from 'date-fns';

@Pipe({
  name: 'duration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  transform(value: number): unknown {
    return formatDuration(
      intervalToDuration({
        start: new Date(),
        end: addMonths(new Date(), value),
      })
    );
  }
}
